export default {
  availableLocales: [
    "fr","en"
  ],
  caseDetails: [
    "name",
    "location",
    "status"
  ], 
  solved: false,
  sections: [
    {
      id: "envelopes",
      route: { name: "stranger-envelopes" }
    },
    {
      id: "evidences",
      subsections: [
        {
          id: "directory",
          lockable: false,
          locked: false,
          route: { name: "stranger-directory" }
        },
        {
          id: "calllist",
          lockable: false,
          locked: false,
          route: { name: "stranger-calllist" }
        },
        {
          id: "videoclub",
          lockable: false,
          locked: false,
          route: { name: "stranger-videoclub" },
          disabled: true,

        },                            
        {
          id: "walkman",
          lockable: false,
          locked: false,               
          route: { name: "stranger-walkman" }
        },                            
        {
          id: "talkiewalkie",
          lockable: false,
          locked: false,               
          route: { name: "stranger-talkiewalkie" },
          disabled: true,
        }
      ]
    },
    {
      id: "clues",
      route: { name: "stranger-clues" }
    }
  ],
  directory: {
    extraAddressNumber: "874987444",
    solved: false
  },
  walkman: {
    currentRadio: 96.1,
    stations: [
      {
        frequency: 95.3,
        name: 'synthwave3',
        direct: true
      },
      {
        frequency: 100.1,
        name: 'synthwave',
        direct: true
      },
      {
        frequency: 105.9,
        name: 'synthwave2',
        direct: true
      },
      {
        frequency: 101.7,
        name: 'pirate',
        direct: false
      }
    ]
  },
  talkiewalkie: {
    currentChannel: [0, 0],
    currentStep: 0,
    correctChannel: [18, 4],
    soundDurations: {
      "start": 28,
      "wrong": 6,
      "danger": 5,
      "roger": 5.5,
      "win": 8,
      "morse": 2.5,
    },
    choices: [
      [ 
        { name: "IT1", outcome: "wrong" },
        { name: "IT2", outcome: "roger"},
        { name: "IT4", outcome: "danger"},          
        { name: "IT5", outcome: "danger"}
      ],
      [ 
        { name: "IT7", outcome: "wrong" },
        { name: "IT6", outcome: "roger"},
        { name: "IT0", outcome: "wrong"}
      ],
      [
        { name: "IT2", outcome: "wrong" },
        { name: "IT5", outcome: "roger"},
        { name: "IT12", outcome: "danger"}        
      ],
      [
        { name: "IT10", outcome: "roger" },
        { name: "IT0", outcome: "danger"},
        { name: "IT6", outcome: "wrong"}        
      ],
      [
        { name: "IT5", outcome: "wrong" },
        { name: "IT15", outcome: "wrong"},
        { name: "IT13", outcome: "roger"}
      ],
      [
        { name: "IT10", outcome: "wrong" },
        { name: "IT12", outcome: "wrong"},
        { name: "IT19", outcome: "win"}        
      ]          
    ]
  },
  envelopes: {
    places: [   
      {
        code: "Q11",
        env: "A", 
        next_step: "env-A1", 
        solved: false,
        found: false,
        config: {
          list_1: "listStreets",
          correct_1: "County Lane Road",
          list_2: "listStreetNumbers",
          correct_2: "75"
        } 
      },
      { 
        code: "K8",
        env: "B", 
        next_step: "env-B1", 
        solved: false,
        found: false,
        config: {
          list_1: "listMotives",
          correct_1: "DARYL"                    
        }
      },
      { 
        code: "L6",
        env: "C", 
        next_step: "env-C1", 
        solved: false,
        found: false,
        config: {
          correct: "Daryl Green"
        } 
      },
      { 
        code: "M8",
        env: "D", 
        next_step: "env-D1", 
        solved: false,
        found: false,
        config: {
          list_1: "listPlaces",
          correct_1: "video",
          list_2: "listChats",
          correct_2: "Heather Lynch",
          list_3: "listSuspects",
          correct_3: "Shaun Patel"
        }
      },
      { 
        code: "L9",
        env: "E", 
        next_step: "env-E2",
        solved: false,
        found: false,
        config: {
          correct: "1945"
        }
      },
      {
        code: "K9",
        env: "VF",
        next_step: "env-VF",
        solved: false,
        found: false,
      },
      { 
        code: "K7",
        env: "F", 
        next_step: "env-F1", 
        solved: false,
        found: false,
        config: {
          list_1: "listFloors",
          correct_1: "4",
          list_2: "listSectors",
          correct_2: "3"
        }
      },
      { 
        code: "T10",
        env: "G", 
        next_step: "env-G1", 
        solved: false,
        found: false,
      },
      {
        code: "P8",
        env: "de-Q12",
        next_step: "env-de-Q12",
        found: false,
      },  
      {
        code: "N16",
        env: "de-N19",
        next_step: "env-de-N19",
        found: false,
      },      
      {
        code: "R5",
        env: "de-T7",
        next_step: "env-de-T7",
        found: false,
      },
    ],
    lists: [
      {
        id: "listStreets",
        translate: false,
        entries: ["Grapeline Road", "Dodsworth", "Limewood", "County Lane Road"]
      },
      {
        id: "listStreetNumbers",
        translate: false,
        entries: ["2", "4", "14", "35", "39", "44", "60", "73", "75", "80"]
      },
      {
        id: "listMotives",
        translate: true,
        entries: ["murder", "theft", "strange_animal", "disapearence", "nothing"]
      },
      {
        id: "listPlaces",
        translate: true,
        entries: ["techno", "provdesk", "prevdeskadj", "rest", "biblio", "video", "foyer", "gym",
                  "hall", "medic", "chemical", "physics", "students", "athletism", "arts", "computers",
                  "math", "muscu", "music", "sciences", "theater", "prof", "study", "classroom", 
                  "secretariat", "basket", "football"]
      },
      {
        id: "listChats",
        translate: false,
        entries: ["Calvin Drexler", "Clarisse Juno", "Daphne Cruz", "Elliot Hargenson", "Emilia Norrick", 
                  "Heather Lynch", "Jasper Vaughn", "Marcus Bellamy", "Melinda Quay", "Nadine Forrel",
                  "Nathan Orlow", "Olivia Kern", "Raymond Skeller", "Tanya Mirewood", "Travis Keltner", "Victor Leeland"]
      },
      {
        id: "listSuspects",
        translate: false,
        entries: ["Amir Jackson", "Brian Cheng", "Calvin Knox", "Chris Daniels", 
                  "Eddie Foster", "Jason Mills", "Liam O'Donnell", "Shaun Patel", "Tyler Griggs"]
      },            
      {
        id: "listFloors",
        translate: false,
        entries: ["1", "2", "3", "4", "5", "6", "7", "8", "9", "10", "11", "12", "13", "14", "15"]
      },
      {
        id: "listSectors",
        translate: false,
        entries: ["1", "2", "3", "4", "5", "6", "7", "8", "9", "10", "11", "12", "13", "14", "15"]
      },            
    ]
  }
}